import { flatten } from 'lodash';
import { getDefaultReasonCodes } from 'utils/ReasonCodesAPI';
export const isValidInvoiceForCreditMemo = (invoice) => {
    if (!invoice) {
        return false;
    }
    const { invoice_type, type } = invoice;
    if (invoice_type !== 'debit' || type !== 'drayage') {
        return false;
    }
    const negativeItems = flatten(invoice.lineItemGroups.map((lineItemGroup) => lineItemGroup === null || lineItemGroup === void 0 ? void 0 : lineItemGroup.lineItems.filter((lineItem) => (lineItem === null || lineItem === void 0 ? void 0 : lineItem.value) < 0)));
    if (negativeItems.length)
        return false;
    return true;
};
export const transformPayload = (data, shipment, invoice) => {
    var _a, _b;
    let charges = data.adjustedItems.map((item) => item._id);
    const groupedChargeTypes = ((_b = (_a = invoice === null || invoice === void 0 ? void 0 : invoice.lineItemGroups) === null || _a === void 0 ? void 0 : _a.find(lineItemGroup => lineItemGroup.shipment_id.toString() === shipment._id.toString())) === null || _b === void 0 ? void 0 : _b.groupedChargeTypes) || [];
    const selectedCharges = {
        [shipment._id]: {
            selected: charges,
            groupedChargeTypes,
        },
    };
    return selectedCharges;
};
export const transformRebillData = (data, shipment) => {
    let rebilledItems = data.adjustedItems.reduce((rebillData, adjustedItem) => {
        rebillData[adjustedItem._id] = Object.assign(Object.assign({}, adjustedItem), { reason_code: adjustedItem.reasonCode, notes: adjustedItem.notes, shipper_unit_qty: adjustedItem.units, shipper_rate: data.rebill ? adjustedItem.amount : 0, type: adjustedItem.type, billing_type: adjustedItem.billing_type, value: adjustedItem.total_amount });
        if (adjustedItem.type === 'shipper_cost') {
            delete rebillData[adjustedItem._id].shipper_unit_qty;
            delete rebillData[adjustedItem._id].shipper_rate;
        }
        return rebillData;
    }, {});
    const rebillInformation = {
        [shipment._id]: Object.assign({ rebill_required: data.rebill }, rebilledItems),
    };
    return rebillInformation;
};
export const fetchCreditMemoReasonCodes = async () => {
    var _a, _b, _c;
    const result = await getDefaultReasonCodes();
    const cmReasonCodes = (_c = (_b = (_a = result
        .find((x) => x.lineOfBusiness === 'drayage' && x.default)) === null || _a === void 0 ? void 0 : _a.categories.find((category) => category.name === 'credit_memo')) === null || _b === void 0 ? void 0 : _b.subCategories.find((subCategory) => subCategory.reasonType === 'Reason Codes')) === null || _c === void 0 ? void 0 : _c.reasonCodes;
    if (cmReasonCodes && cmReasonCodes.length) {
        return cmReasonCodes;
    }
    return [];
};
